export const getTodayAsUnixDate = () => {
  const today = new Date();
  return today.getTime(); // This returns the current time in milliseconds since the Unix epoch
};
